<div class="login-wrapper">
  <div class="login">
    <form clrForm [formGroup]="loginGroup" (ngSubmit)="doLogin($event)">
      <section class="title">
        <h3 class="welcome">{{ 'Willkommen bei' | mrTranslate }}</h3>
        <img
          src="assets/mrprocloudlogo{{ !isDarkThemeAktiv ? '-dark' : '' }}.svg"
          class="mw-100-p"
          style="max-height: 180px" />
      </section>
      <div class="login-group">
        <clr-input-container>
          <label>{{ 'Email' | mrTranslate }}</label>
          <input clrInput type="email" formControlName="email" data-test-id="login-user-email" />
        </clr-input-container>
        <clr-input-container>
          <label>{{ 'Passwort' | mrTranslate }}</label>
          <input clrInput type="password" formControlName="password" data-test-id="login-user-password" />
        </clr-input-container>
        <button type="submit" class="btn btn-primary" data-test-id="login-submit-button">
          {{ 'Anmelden' | mrTranslate }}
        </button>
      </div>
    </form>
    <button class="button-link" (click)="isforgotPWModalVisible = true" data-test-id="login-user-btn">
      {{ 'Passwort vergessen ?' | mrTranslate }}
    </button>
    @if (showOktaLogin) {
      <button class="button-link" (click)="oktaLogin()" id="login-button" data-test-id="login-okta-btn" role="button">
        {{ 'Okta Anmeldung' | mrTranslate }}
      </button>
    }
    @if (showMsalLogin) {
      <button class="button-link" (click)="msalLogin()" id="login-button" data-test-id="login-msal-btn" role="button">
        {{ 'Anmelden mit Entra-ID' | mrTranslate }}
      </button>
    }
  </div>
</div>

@if (isforgotPWModalVisible) {
  <clr-modal
    [(clrModalOpen)]="isforgotPWModalVisible"
    [clrModalSize]="'md'"
    [clrModalClosable]="true"
    data-test-id="forgot-password-modal">
    <h3 class="modal-title">{{ 'Passwort vergessen ?' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        <p>
          {{
            'Um Ihr Passwort zurückzusetzen, geben Sie bitte Ihre E-Mail-Adresse in das untenstehende Feld ein. Sie erhalten dann einen Code per E-Mail.'
              | mrTranslate
          }}
        </p>
        <clr-input-container>
          <label class="clr-col-md-1">{{ 'Email' | mrTranslate }}</label>
          <input
            style="width: 400px"
            clrInput
            id="exforgotemail"
            type="email"
            #exmail
            data-test-id="forgot-password-email" />
          <br />
        </clr-input-container>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="getMail($event)" data-test-id="forgot-password-submit">
        {{ 'Senden' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="isforgotPWModalVisible = false" data-test-id="forgot-password-cancel">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

@if (isTenentMailVisible) {
  <clr-modal
    [clrModalOpen]="isTenentMailVisible"
    (clrModalOpenChange)="handleMsalTenantModalOpenChange($event)"
    [clrModalSize]="'md'"
    [clrModalClosable]="true"
    data-test-id="tenant-mail-modal">
    <h3 class="modal-title">{{ 'Konfiguration für SSO fehlt' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        <p>{{ 'Bitte geben Sie ihre Email unter ein.' | mrTranslate }}</p>
        <clr-input-container>
          <label class="clr-col-md-1">{{ 'Email' | mrTranslate }}</label>
          <input
            style="width: 400px"
            clrInput
            id="tenant-email"
            type="email"
            [(ngModel)]="msalEmail"
            (ngModelChange)="onMsalEmailChange($event)"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="getMSALMail()"
            [disabled]="isMsalConfigLoading || isMsalLoginInProgress"
            data-test-id="tenant-mail-input" />
          <br />
        </clr-input-container>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="getMSALMail()"
        [disabled]="isMsalConfigLoading || isMsalLoginInProgress"
        data-test-id="tenant-mail-submit">
        {{
          (isMsalConfigLoading || isMsalLoginInProgress
            ? 'Prüfen...'
            : pendingMsalConfig
              ? 'Mit Microsoft anmelden'
              : 'Senden'
          ) | mrTranslate
        }}
      </button>
      <button type="button" class="btn" (click)="closeMsalTenantModal()" data-test-id="tenant-mail-cancel">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

@if (isCodeModalVisible) {
  <clr-modal
    [(clrModalOpen)]="isCodeModalVisible"
    [clrModalSize]="'md'"
    [clrModalClosable]="true"
    data-test-id="confirmation-code-modal">
    <h3 class="modal-title">{{ 'Bestätigungscode eingeben' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        <p>{{ 'Bitte geben Sie ihren Bestätigungscode ein.' | mrTranslate }}</p>
        <clr-input-container>
          <label class="clr-col-md-1">{{ 'Code' | mrTranslate }}</label>
          <input clrInput style="width: 200px" id="excode" type="text" #excode data-test-id="confirmation-code-input" />
          <br />
        </clr-input-container>
        <br />
        <br />
        <div class="progress-block">
          <clr-progress-bar
            style="height: 5px"
            id="progressbar"
            mode="determinate"
            [clrValue]="progressbarValue"></clr-progress-bar>
        </div>
        <div>
          <span>{{ dateSec }}</span>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="getValidCode($event)">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="isCodeModalVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}

@if (isNewPasswordVisible) {
  <clr-modal [(clrModalOpen)]="isNewPasswordVisible" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Neues Passwort erstellen' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        <clr-input-container>
          <label class="clr-col-md-5">{{ 'neues Passwort' | mrTranslate }}</label>
          <input clrInput style="width: 400px" id="exnewpw" type="password" #exnewpw />
          <br />
        </clr-input-container>
        <clr-input-container>
          <label class="clr-col-md-5">{{ 'Passwort bestätigen' | mrTranslate }}</label>
          <input clrInput style="width: 400px" id="exnewpwconf" type="password" #exnewpwconf />
          <br />
        </clr-input-container>
        <div>
          <br />
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="setNewPassword($event)">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="isNewPasswordVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}

@if (isRSVDatabaseSelectVisible) {
  <clr-modal
    [(clrModalOpen)]="isRSVDatabaseSelectVisible"
    [clrModalSize]="'md'"
    [clrModalClosable]="true"
    data-test-id="database-selection-modal">
    <h3 class="modal-title">{{ 'Kundendatenbank auswählen' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="vertical" class="w-100-p width100" style="max-width: 400px">
        <clr-select-container>
          <select clrSelect #seldb data-test-id="database-dropdown">
            <option [ngValue]="null" disabled selected data-test-id="database-option-placeholder">
              {{ 'Kundendatenbank auswählen' | mrTranslate }}
            </option>
            @for (db of dbs; track db; let i = $index) {
              <option [value]="db.name" [attr.data-test-id]="'database-option-' + i">{{ db.kunde }}</option>
            }
          </select>
        </clr-select-container>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="seldb.value && doLoginIntern($event)"
        data-test-id="database-selection-submit">
        OK
      </button>
      <button type="button" class="btn" (click)="isRSVDatabaseSelectVisible = false">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

@if (is2FA) {
  <clr-modal [(clrModalOpen)]="is2FA" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Anmeldung bestätigen' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        @if (timer2FAfinished == false) {
          <div>
            <p>{{ 'Bitte geben Sie ihren SMS-Bestätigungscode ein.' | mrTranslate }}</p>
            <br />
            <div class="clr-input-wrapper">
              <input
                clrinput=""
                placeholder="SMS-Code"
                id="excode"
                type="text"
                style="width: 350px"
                #excode
                class="clr-input" />
            </div>
            <br />
            <br />
          </div>
        } @else {
          <p style="background-color: Tomato; padding: 15px">
            {{
              'Die Zeit für die Eingabe eines Bestätigungscodes ist abgelaufen. Bitte fordern Sie eine neuen Code per SMS an.'
                | mrTranslate
            }}
          </p>
          <br />
          <br />
        }
        <div class="clr-row">
          <div class="clr-col-6">
            <span>{{ 'Keinen Code erhalten?' | mrTranslate }}</span>
          </div>
          <div class="clr-col-6">
            <a href="javascript://" (click)="do2FAsendSMS()" class="signup">{{ 'Nochmals senden' | mrTranslate }}</a>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="do2FA($event)" [disabled]="timer2FAfinished == true">
        {{ 'OK' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="is2FA = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}

@if (googleSetupShow) {
  <clr-modal [(clrModalOpen)]="googleSetupShow" [clrModalSize]="'lg'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ '2‑Faktor-Authentifizierung mit Google Authenticator' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal">
        <strong>{{ '1. Schritt' | mrTranslate }}</strong>
        <div>
          {{ 'Um die Google Autenthicator App zu nutzen, müssen Sie den folgenden QR-Code scannen:' | mrTranslate }}
        </div>
        <br />
        <img [src]="googleqrimage" style="display: block; margin-left: auto; margin-right: auto; width: 40%" />
        <br />
        <div>{{ 'Alternativ können sie folgenden Code in die Google Autenthicator App eingeben:' | mrTranslate }}</div>
        <div style="font-size: 10px">{{ googleentrykey }}</div>
        <br />
        <br />
        <strong>{{ '2. Schritt' | mrTranslate }}</strong>
        <div>{{ 'Geben Sie den 6-stelligen Code aus der Autenthicator App ein.' | mrTranslate }}</div>
        <!-- <div class="clr-input-wrapper">
          <input clrinput="" placeholder="Code" id="excode" type="text" style="width: 200px;"  #input class="clr-input" (keyup.enter)="verifyGoogleCode()">
        </div> -->
        <code-input
          #codeInput
          [isCodeHidden]="false"
          [initialFocusField]="0"
          [codeLength]="6"
          (codeCompleted)="onCodeCompletedSave($event)"></code-input>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="verifyGoogleCodes()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="googleSetupShow = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}

@if (googleCodeShow) {
  <clr-modal [(clrModalOpen)]="googleCodeShow" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Multi-Faktor-Authentifizierung (MFA)' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal">
        <div>{{ 'Bestätigungscode' | mrTranslate }} *</div>
        <!-- <div class="clr-input-wrapper" style="margin-top: 10px;">
        <input clrinput="" placeholder="Code" id="excode" type="text" style="width: 200px;" #input class="clr-input" (keyup.enter)="verifyGoogleCode()">
      </div> -->
        <code-input
          id="code"
          #codeInput
          style="margin-top: 10px; margin-left: -10px"
          [isCodeHidden]="false"
          [initialFocusField]="0"
          [codeLength]="6"
          (codeCompleted)="onCodeCompleted($event)"
          [ngStyle]="{ color: codeColor }"></code-input>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="verifyGoogleCodes()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="googleCodeShow = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}

@if (isFailedCodeVisible) {
  <clr-modal [(clrModalOpen)]="isFailedCodeVisible" [clrModalSize]="'lg'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Sicherheitsüberprüfung' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal">
        <div>{{ 'Sehr geehrte*r' | mrTranslate }} {{ name + ',' }}</div>
        <br />
        <div>
          {{
            'wir möchten Sie darüber informieren, dass Ihr Passwort mehrfach falsch eingegeben wurde. Aus Sicherheitsgründen wurde der Zugriff vorübergehend gesperrt, um unbefugte Zugriffe zu verhindern.'
              | mrTranslate
          }}
        </div>
        <br />
        <div>
          {{
            'Falls Sie selbst die Eingaben vorgenommen haben, stellen Sie bitte sicher, dass Sie das richtige Passwort verwenden. Sollten Sie Ihr Passwort vergessen haben, wenden Sie sich bitte an Ihren Administrator.'
              | mrTranslate
          }}
        </div>
        <br />
        <div>
          {{
            'Aus Sicherheitsgründen ist die Eingabe des Bestätigungscodes, den Sie per EMail erhalten haben, erforderlich.'
              | mrTranslate
          }}
        </div>
        <div class="clr-input-wrapper" style="margin-top: 15px">
          <input
            clrinput=""
            placeholder="Code"
            id="excode"
            type="text"
            style="width: 200px"
            #input
            class="clr-input"
            (keyup.enter)="verifyLoginFailedCode()" />
        </div>
        <br />
        <div>{{ 'Vielen Dank für Ihr Verständnis' | mrTranslate }}</div>
        <div>{{ 'Ihre MR.pro® Team' | mrTranslate }}</div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="verifyLoginFailedCode()">{{ 'OK' | mrTranslate }}</button>
      <!-- <button type="button" class="btn" (click)="googleCodeShow = false">{{ "Abbrechen" | mrTranslate }}</button> -->
    </div>
  </clr-modal>
}

<!-- MODAL PASSWORT ÄNDERN -->
@if (changePassword) {
  <clr-modal [(clrModalOpen)]="changePassword" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Passwortänderung erforderlich' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm [formGroup]="passwordGroup" clrLayout="vertical" style="margin-top: 0px">
        <p style="margin-top: -10px">
          {{ 'Auf Grund geänderter Passwortrichtlinien muss das Passwort geändert werden.' | mrTranslate }}
        </p>
        <div class="clr-row">
          <div class="clr-control-container" style="width: 400px; margin-left: 30px">
            <clr-password-container>
              <input
                clrPassword
                placeholder="{{ 'aktuelles Passwort' | mrTranslate }}"
                name="password"
                formControlName="opw"
                style="width: 300px" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-password-container>
          </div>
        </div>
        <div class="clr-row">
          <div class="clr-control-container" style="width: 400px; margin-left: 30px">
            <clr-password-container>
              <input
                clrPassword
                autocomplete="off"
                placeholder="{{ 'neues Passwort' | mrTranslate }}"
                name="password"
                formControlName="npw"
                style="width: 300px" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-password-container>
          </div>
        </div>
        <div class="clr-row">
          <div class="clr-control-container" style="width: 400px; margin-left: 30px">
            <clr-password-container>
              <input
                clrPassword
                autocomplete="off"
                placeholder="{{ 'Passwort bestätigen' | mrTranslate }}"
                name="password"
                formControlName="npw1"
                style="width: 300px" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-password-container>
          </div>
        </div>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="ResetRequiredPassword()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="changePassword = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
